import { Pagination } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
  total?: number;
  itemsPerPage?: number;
  page?: number;
  hidden?: boolean;
  totalPages?: number;
  disabled?: boolean;

  handleChangePage(event: unknown, newPage: number): void;
}

const PaiPagination: React.FC<Props> = ({ total, itemsPerPage, page, hidden, totalPages, disabled, handleChangePage }) => {
  const { classes } = useStyles();

  return (
    <Pagination
      className={classes.pagination}
      count={!_.isNil(totalPages) ? totalPages : !_.isNil(total) && !_.isNil(itemsPerPage) ? Math.ceil(total / +itemsPerPage) : undefined}
      page={page}
      onChange={handleChangePage}
      showFirstButton={false}
      showLastButton={false}
      shape={'rounded'}
      siblingCount={1}
      boundaryCount={1}
      size={'small'}
      color={'primary'}
      disabled={disabled}
      style={{ visibility: !hidden ? 'visible' : 'hidden' }}
    />
  );
};

const useStyles = makeStyles()((theme) => ({
  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexWrap: 'nowrap',
    [theme.breakpoints.down(400)]: {
      '& button': {
        fontSize: theme.typography.pxToRem(10),
        padding: '0 2px',
        minWidth: '20px',
        height: '20px',
      },
      '& svg': {
        fontSize: theme.typography.pxToRem(14),
      },
    },
  },
}));

export default PaiPagination;
